import React from "react";
import Progress1Svg from "../../../assets/svgicons/progress-bar/progress_bar_1.svg";

const Progress1 = (props) => {
  return <img src={Progress1Svg} alt="Progress 1" {...props} />;
};

export default Progress1;
